import AccountList from "../components/account/AccountList";

const AccountSettingPage = () => {
    return (
        <AccountList />
    );
}

export default AccountSettingPage;